// ═══════════════════════════════════════════════════════════════
//  击杀奖励 / 掉落 / 拾取收益 —— 参数的【单一来源】
//  之前这些倍率散落在多处（分数、药水掉落、金币数量各写一遍），
//  现在统一在此定义，任何地方都从这里引用。
// ═══════════════════════════════════════════════════════════════

/** 怪物强度档：普通 / 精英 / BOSS */
export interface Tiered {
  isElite?: boolean;
  isBoss?: boolean;
}

/** 击杀得分倍率（按档位） */
export function scoreMultiplier(e: Tiered): number {
  return e.isBoss ? 20 : e.isElite ? 5 : 1;
}

/** 基础击杀得分（再乘楼层与 scoreMul） */
export const KILL_BASE_SCORE = 10;

/** 药水掉落概率（按档位） */
export function potionDropChance(e: Tiered): number {
  return e.isBoss ? 1 : e.isElite ? 0.9 : 0.18;
}

/** 金币掉落数量（按档位；普通怪有概率掉 1 枚） */
export function coinDropCount(e: Tiered): number {
  if (e.isBoss) return 8;
  if (e.isElite) return 3;
  return Math.random() < 0.55 ? 1 : 0;
}

/** 单枚金币价值随楼层成长 */
export function coinValue(floor: number): number {
  return 5 + floor * 2;
}

// ── 拾取物收益 ────────────────────────────────────────────────
export const CHEST_SCORE = 50;   // 再乘 scoreMul
export const CHEST_HEAL = 20;
export const CHEST_COINS = 3;
export const POTION_HEAL = 30;

/** 通过（下行）一层门的奖励分（再乘楼层与 scoreMul） */
export const FLOOR_CLEAR_SCORE = 50;
